import { computed, onBeforeUnmount, onMounted, ref } from 'vue-demi';

export function formatRemain(remainMs: number, isEn = false): string {
  const unit = isEn ? 'd' : '天';
  if (remainMs <= 0) {
    return `0${unit} 00:00:00`;
  }
  const totalSec = Math.floor(remainMs / 1000);
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;
  const pad = (n: number) => (n < 10 ? `0${n}` : String(n));
  return `${days}${unit} ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

export function useCountdown(
  getEndAt: () => number | null,
  getIsEn: () => boolean = () => false,
) {
  const now = ref(Date.now());
  let timer: ReturnType<typeof setInterval> | null = null;

  const remainMs = computed(() => {
    const endAt = getEndAt();
    if (!endAt) {
      return 0;
    }
    return Math.max(0, endAt - now.value);
  });

  const text = computed(() => formatRemain(remainMs.value, getIsEn()));
  const ended = computed(() => {
    const endAt = getEndAt();
    return !!endAt && remainMs.value <= 0;
  });

  onMounted(() => {
    timer = setInterval(() => {
      now.value = Date.now();
    }, 1000);
  });

  onBeforeUnmount(() => {
    if (timer) {
      clearInterval(timer);
    }
  });

  return { remainMs, text, ended };
}
